export default __webpack_public_path__ + "static/media/whatsstartupindia.43e1449b.svg";